import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import EscrowSubmission from './components/EscrowSubmission';
import ClientsList from './components/ClientsList';
import PaymentsList from './components/PaymentsList';
import ClientInstance from './components/ClientInstance';
import ContractInstance from './components/ContractInstance';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import ResetPassword from './components/ResetPassword';
import TestNewPage from './components/TestNewPage';
import Search from './components/Search';
import TestModal from './components/TestModal';
import Dashboard from './components/Dashboard';
import AnotherTest from './components/AnotherTest';
import EscrowPaymentsPage from './components/EscrowPaymentsPage';
import EscrowPaymentsPagePreview from './components/EscrowPaymentsPagePreview';
import ContractsList2 from './components/ContractsList2';
import PaymentInstance from './components/PaymentInstance';
import ConfirmEmail from './components/ConfirmEmail';
import GetStarted from './components/GetStarted';
import EmailVerifiedRoute from './components/EmailVerifiedRoute';
import OnboardVerifiedRoute from './components/OnboardVerifiedRoute';
import InvoiceDetails from './components/InvoiceDetails';
import CurrentInvoicePaymentsPagePreview from './components/CurrentInvoicePaymentsPagePreview';
import CurrentInvoicePaymentsPage from './components/CurrentInvoicePaymentsPage';
import BillingSettings from './components/BillingSettings';
import AuthTest from './components/AuthTest';
import OnboardingOwnerDetailsRetry from './components/OnboardingOwnerDetailsRetry';
import OnboardingOwnerDetailsDocument from './components/OnboardingOwnerDetailsDocument';
import VerifyEmail from './components/VerifyEmail';
import Signup2 from './components/Signup2';
import Login2 from './components/Login2';
import OnboardingPersonalSuccess from './components/OnboardingPersonalSuccess';
import OnboardingBizSuccess from './components/OnboardingBizSuccess';
import OnboardingPersonalFail from './components/OnboardingPersonalFail';
import OnboardingBizFail from './components/OnboardingBizFail';
import OnboardingBizSuccess2 from './components/OnboardingBizSuccess2';
// import Developer from "./components/Developer";
import Developer2 from './components/Developer2';
import Roles from './components/Roles';
import NewCardForm from './components/NewCardForm';
import NewSetupDetails from './components/NewSetupDetails';
import NewOnboardingBankingDetails from './components/NewOnboardingBankingDetails';
import NewPlanInformation from './components/NewPlanInformation';
import NewConfirmIdentity from './components/NewConfirmIdentity';
import NewApplicationReceived from './components/NewApplicationReceived';
import CreateChildUserPage from './components/CreateChildUserPage';
import SubscriptionDetails from './components/SubscriptionDetails';
import SubscriptionPaymentsPagePreview from './components/SubscriptionPaymentsPagePreview';
import SubscriptionPaymentsPage from './components/SubscriptionPaymentsPage';
import DebtorSubmission from './components/DebtorSubmission';
import DebtorSubmissionLoading from './components/DebtorSubmissionLoading';
import DebtorsList from './components/DebtorsList';
import DebtorsListLoading from './components/DebtorsListLoading';
import DebtorDetails from './components/DebtorDetails';
import ViewDebtor from './components/ViewDebtor';
import UpdateInformation from './components/UpdateInformation';
import CardForm from './components/CardForm';
import AllDebtors from './components/AllDebtors';
import MasterViewDebtor from './components/MasterViewDebtor';
import FolderUploader from './components/FolderUploader';
import UsagePage from './pages/UsagePage';
import SignOut from './components/SignOut';
import RetellCallHistoryPage from './pages/RetellCallHistoryPage';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login2 />} />
          <Route path="/signup" element={<Signup2 />} />
          <Route path="/signout" element={<SignOut />} />
          <Route path="/forgotpassword" element={<ResetPassword />} />
          <Route path="/anothertes" element={<AnotherTest />} />
          <Route path="/verifyEmail" element={<VerifyEmail />} />
          <Route
            path="/milestonepayments/:paymentId"
            element={<EscrowPaymentsPage />}
          />
          <Route
            path="/invoicepayments/:paymentId"
            element={<CurrentInvoicePaymentsPage />}
          />
          <Route
            path="/subscriptionpayments/:paymentId"
            element={<SubscriptionPaymentsPage />}
          />
          <Route path="/test-this" element={<TestNewPage />} />
          <Route
            path="/onboarding-propay"
            element={<OnboardingBizSuccess2 />}
          />
          <Route path="/authtest" element={<AuthTest />} />
          <Route path="/newcardform" element={<NewCardForm />} />
          <Route
            path="/createChildUserPage"
            element={<CreateChildUserPage />}
          />
          <Route path="/testpayment" element={<CardForm />} />
          <Route element={<PrivateRoute />}>
            <Route path="/verify-email" element={<ConfirmEmail />} />
            <Route path="/testmodal" element={<TestModal />} />
          </Route>
          <Route element={<EmailVerifiedRoute />}>
            <Route path="get-started" element={<GetStarted />} />
            <Route path="onboarding" element={<NewSetupDetails />} />
            <Route
              path="onboarding-banking-details"
              element={<NewOnboardingBankingDetails />}
            />
            <Route
              path="onboarding-plan-information"
              element={<NewPlanInformation />}
            />
            <Route
              path="onboarding-confirm-identity"
              element={<NewConfirmIdentity />}
            />
            <Route
              path="application-received"
              element={<NewApplicationReceived />}
            />
            <Route
              path="verify-owners"
              element={<OnboardingOwnerDetailsRetry />}
            />
            <Route
              path="verify-owners-document"
              element={<OnboardingOwnerDetailsDocument />}
            />
            <Route
              path="account-approved"
              element={<OnboardingPersonalSuccess />}
            />
            <Route
              path="business-approved"
              element={<OnboardingBizSuccess />}
            />
            <Route
              path="account-unapproved"
              element={<OnboardingPersonalFail />}
            />
            <Route path="business-unapproved" element={<OnboardingBizFail />} />
          </Route>

          {/* onboarding-complete wrapper */}
          <Route element={<OnboardVerifiedRoute />}>
            {/* “/” */}
            <Route index element={<Dashboard />} />

            {/* settings */}
            <Route path="settings/billing" element={<BillingSettings />} />

            {/* core app pages */}
            <Route path="roles" element={<Roles />} />
            <Route path="developer" element={<Developer2 />} />
            <Route path="submitdebts" element={<DebtorSubmission />} />
            <Route
              path="submitdebtsloading"
              element={<DebtorSubmissionLoading />}
            />
            <Route path="folderuploader" element={<FolderUploader />} />
            <Route path="testsearch" element={<Search />} />

            {/* previews */}
            <Route
              path="invoice-preview"
              element={<CurrentInvoicePaymentsPagePreview />}
            />
            <Route
              path="subscription-preview"
              element={<SubscriptionPaymentsPagePreview />}
            />
            <Route
              path="escrowpayment-preview"
              element={<EscrowPaymentsPagePreview />}
            />

            {/* submissions */}
            <Route path="contractsubmission" element={<EscrowSubmission />} />
            <Route path="invoicesubmission" element={<InvoiceDetails />} />
            <Route
              path="subscriptionsubmission"
              element={<SubscriptionDetails />}
            />
            <Route path="updateinformation" element={<UpdateInformation />} />

            {/* debtors / clients */}
            <Route path="viewdebtor/:id" element={<ViewDebtor />} />
            <Route path="masterviewdebtor/:id" element={<MasterViewDebtor />} />
            <Route path="debtordetails" element={<DebtorDetails />} />
            <Route path="clientslist" element={<ClientsList />} />
            <Route path="debtorslist" element={<DebtorsList />} />
            <Route path="debtorslistloading" element={<DebtorsListLoading />} />
            <Route path="alldebtors" element={<AllDebtors />} />

            <Route path="paymentslist" element={<PaymentsList />} />
            <Route path="contractslist" element={<ContractsList2 />} />

            {/* instances */}
            <Route path="debtor/:id" element={<ClientInstance />} />
            <Route path="contract/:contractId" element={<ContractInstance />} />
            <Route
              path="payment/:paymentDataId"
              element={<PaymentInstance />}
            />

            {/* usage */}
            <Route path="usage" element={<UsagePage />} />

            {/* call history */}
            <Route path={'calls/history'} element={<RetellCallHistoryPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
